import { z } from 'zod';
import { globalSearchSchema } from 'src/modules/shared/schemas/search.schema';

/**
 * Schema for validating search parameters in the employees list view.
 * Extends the global search schema and transforms phoneVersion to always be 'v1'.
 */
export const employeesSearchSchema = globalSearchSchema.merge(
  z.object({
    phoneVersion: globalSearchSchema.shape.phoneVersion.default('v1' as const),
  })
);
/**
 * Type definition for the employees search parameters.
 */
export type EmployeesSearch = z.infer<typeof employeesSearchSchema>;

/**
 * Schema for validating URL path parameters when accessing a specific employee.
 * Requires a valid employeeId string.
 */
export const employeePathSchema = z.object({
  employeeId: z.string(),
});
/**
 * Type definition for employee path parameters.
 */
export type EmployeePath = z.infer<typeof employeePathSchema>;

/**
 * Schema for validating search parameters in the single employee view.
 * Extends the employees search schema with no additional parameters.
 */
export const employeeSearchSchema = employeesSearchSchema.merge(z.object({}));
/**
 * Type definition for the single employee search parameters.
 */
export type EmployeeSearch = z.infer<typeof employeeSearchSchema>;

/**
 * Schema for validating search parameters in the new employee view.
 * Extends the employees search schema with no additional parameters.
 */
export const newEmployeeSearchSchema = employeesSearchSchema.merge(
  z.object({})
);
/**
 * Type definition for the new employee search parameters.
 */
export type NewEmployeeSearch = z.infer<typeof newEmployeeSearchSchema>;
